import { Badge, Box, DialogBody, Flex, HStack, Image, Separator, Stack, Text } from "@chakra-ui/react";
import { UI } from "components";

export default function Pins({ ...props }){

    const careers = [
        {
            label: 'Empreendedor',
            vme: '1.225',
            points: '950',
            award: '100,00',
            src: 'https://generic.nyc3.cdn.digitaloceanspaces.com/static/pins/01EMPREENDEDOR.png'
        },{
            label: 'Senior',
            vme: '3.800',
            points: '2.450',
            award: '200,00',
            src: 'https://generic.nyc3.cdn.digitaloceanspaces.com/static/pins/02SENIOR.png'
        },{
            label: 'Expert',
            vme: '5.000',
            points: '7.250',
            award: '700,00',
            src: 'https://generic.nyc3.cdn.digitaloceanspaces.com/static/pins/03EXPERT.png'
        },{
            label: 'Enterprise',
            vme: '16.000',
            points: '14.750',
            award: '1.300,00',
            src: 'https://generic.nyc3.cdn.digitaloceanspaces.com/static/pins/04ENTERPRISE.png'
        },{
            label: 'Diamond',
            vme: '25.000',
            points: '27.500',
            award: '4.000,00',
            src: 'https://generic.nyc3.cdn.digitaloceanspaces.com/static/pins/05DIAMOND.png'
        },{
            label: 'Diamond Expert',
            vme: '42.000',
            points: '60.500',
            award: '12.000,00',
            src: 'https://generic.nyc3.cdn.digitaloceanspaces.com/static/pins/06DIAMOND%20EXPERT.png'
        },{
            label: 'Diamond Global',
            vme: '90.000',
            points: '122.500',
            award: '24.000,00',
            src: 'https://generic.nyc3.cdn.digitaloceanspaces.com/static/pins/07DIAMOND%20GLOBAL.png'
        },{
            label: 'Empresarial Diamond',
            vme: '180.000',
            points: '247.500',
            award: '34.000,00',
            src: 'https://generic.nyc3.cdn.digitaloceanspaces.com/static/pins/08EMPRESARIAL%20DIAMOND.png'
        },{
            label: 'Imperial Bonific',
            vme: '368.750',
            points: '495.000',
            award: '60.000,00',
            src: 'https://generic.nyc3.cdn.digitaloceanspaces.com/static/pins/09IMPERIAL%20BONIFIC.png'
        },{
            label: 'Majestic Bonific',
            vme: '750.000',
            points: '1.475.000',
            award: '130.000,00',
            src: 'https://generic.nyc3.cdn.digitaloceanspaces.com/static/pins/10MAJESTIC%20BONIFIC.png'
        },{
            label: 'Presidencial',
            vme: '-',
            points: '3.000.000',
            award: '250.000,00',
            src: 'https://generic.nyc3.cdn.digitaloceanspaces.com/static/pins/11PRESIDENCIAL.png'
        }
    ]
    return(
    <UI.Dialog title="Pins de qualificação" {...props}>
        <DialogBody>

            <Stack gap={6}>

                <Box>
                    <HStack gap={4}>
                        <Image w="40px" src="https://generic.nyc3.cdn.digitaloceanspaces.com/static/pins/00CONSULTOR.png" />
                        <Box>
                            <Text fontWeight="bold">Consultor</Text>
                            <Text fontSize="xs" color="GrayText">Pin inicial da Bonífica</Text>
                            <Text fontSize="xs" color="GrayText"><b>VME:</b> 450 pontos</Text>
                        </Box>
                    </HStack>
                </Box>

                { careers.map(item => <Career key={item.label} {...item} />) }

            </Stack>
        </DialogBody>
    </UI.Dialog>
    )
}

const Career = ({ label, src, points = 0, vme = 0, award = 0 }) => {
    return(
    <>
    <Separator />
    <Box>
        <Flex alignItems="center" justifyContent="space-between">
            <HStack gap={4}>
                <Image w="40px" src={src} />
                <Box>
                    <Text fontWeight="bold">{label}</Text>
                    <Text fontSize="xs" color="GrayText"><b>Pontos necessários:</b> {points} pontos</Text>
                    <Text fontSize="xs" color="GrayText"><b>VME:</b> {vme} pontos</Text>
                </Box>
            </HStack>
            <Box textAlign="center">
                <Text fontSize="xs" color="GrayText">Premiação:</Text>
                <Badge size="lg" colorPalette="teal">R$ {award}</Badge>
            </Box>
        </Flex>
    </Box>
    </>
    )
}